//= include common/template.js
//= include app/components/select.js

 $(document).ready(function() {
	 
	$('.advantages-slider').slick({
		arrows: true,
		prevArrow: '<svg class="arrows cercle-left-arrow" style="width:2.5rem; height:2.5rem;"><use xlink:href="#cercle-left-arrow"></use></svg>',
		nextArrow: '<svg class="arrows cercle-right-arrow" style="width:2.5rem; height:2.5rem;"><use xlink:href="#cercle-right-arrow"></use></svg>',
		infinite: true,
		speed: 1000,
		slidesToShow: 4,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 550,
				settings: {
					slidesToShow: 1,
				}
			}
		]
	}).removeClass('hide');

	$('.carriers-slider').slick({
		arrows: true,
		prevArrow: '<svg class="arrows cercle-left-arrow" style="width:2.5rem; height:2.5rem;"><use xlink:href="#cercle-left-arrow"></use></svg>',
		nextArrow: '<svg class="arrows cercle-right-arrow" style="width:2.5rem; height:2.5rem;"><use xlink:href="#cercle-right-arrow"></use></svg>',
		infinite: true,
		speed: 1000,
		slidesToShow: 6,
		slidesToScroll: 3,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					speed: 800,
					slidesToShow: 5,
					slidesToScroll: 5,
				}
			},
			{
				breakpoint: 900,
				settings: {
					speed: 800,
					slidesToShow: 4,
					slidesToScroll: 4,
				}
			}
			,
			{
				breakpoint: 700,
				settings: {
					speed: 800,
					slidesToShow: 3,
					slidesToScroll: 3,
				}
			}
			,
			{
				breakpoint: 500,
				settings: {
					speed: 800,
					slidesToShow: 2,
					slidesToScroll: 2,
				}
			}
		]
	}).removeClass('hide');

	$('.testimonials-slider').slick({
		arrows: true,
		prevArrow: '<svg class="arrows cercle-left-arrow" style="width:2.5rem; height:2.5rem;"><use xlink:href="#cercle-left-arrow"></use></svg>',
		nextArrow: '<svg class="arrows cercle-right-arrow" style="width:2.5rem; height:2.5rem;"><use xlink:href="#cercle-right-arrow"></use></svg>',
		infinite: true,
		speed: 1000,
		slidesToShow: 3,
		slidesToScroll: 3,
		responsive: [
			{
				breakpoint: 1225,
				settings: {
					speed: 800,
					slidesToShow: 2,
					slidesToScroll: 2,
				}
			},
			{
				breakpoint: 925,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			}
		]
	}).removeClass('hide');

	$('.features-slider').slick({
		arrows: true,
		prevArrow: '<svg class="arrows cercle-left-arrow" style="width:2.5rem; height:2.5rem;"><use xlink:href="#cercle-left-arrow"></use></svg>',
		nextArrow: '<svg class="arrows cercle-right-arrow" style="width:2.5rem; height:2.5rem;"><use xlink:href="#cercle-right-arrow"></use></svg>',
		infinite: true,
		speed: 1000,
		slidesToShow: 4,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 550,
				settings: {
					slidesToShow: 1,
				}
			}
		]
	}).removeClass('hide');

	$('.press-slider').slick({
		arrows: true,
		prevArrow: '<svg class="arrows cercle-left-arrow" style="width:2.5rem; height:2.5rem;"><use xlink:href="#cercle-left-arrow"></use></svg>',
		nextArrow: '<svg class="arrows cercle-right-arrow" style="width:2.5rem; height:2.5rem;"><use xlink:href="#cercle-right-arrow"></use></svg>',
		infinite: true,
		speed: 1000,
		slidesToShow: 4,
		slidesToScroll: 4,
		adaptiveHeight: false,
		responsive: [
			{
				
				breakpoint: 1290,
				settings: {
					speed: 800,
					slidesToShow: 3,
					slidesToScroll: 3,
				}
			},
			{
				breakpoint: 950,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 670,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			}
		]
	}).removeClass('hide');
	 
	var $errorMessage = $('.error-popin'); 
	if ($errorMessage.length) {
		window.App.Component.Alert.showPopup($errorMessage.html(), 'alert', __('authentification.fail'));
	}

	$(document).on('keyup', '.security-password', Foundation.util.throttle(function(event) {
	    var password = $(this).val();
	    updateSecurityBar(checkPassStrength(password));
	}, 500));

    if($('input[name="password"]').val()) {
        $('input[name="password"]').trigger('change');
    }
    $('input[name="password"]').keyup(function(){
        let $icon = $(this).next('.password-icon');
        if($icon.length && $(this).val()) {
            $(this).parent('label').removeClass('is-invalid-label');
            $icon.show();
        }
    });
    $('input[name="password"]').blur(function(){
        if($(this).parent('label').hasClass('is-invalid-label')) {
            $(this).next('.password-icon').hide();
        }
    });
    $('.password-icon').click(function(){
        let $input =  $(this).prev('input');
        if($input.attr('type') == 'password') {
            $input.attr('type', 'text');
        } else {
            $input.attr('type', 'password');
        }
    })

// remplace les placehoder non pris en charge sur ie9 pour les remplacer par des values
    if(App.BrowserDetection.isIe9()) {
        $('[placeholder]').focus(function() {
         var input = $(this);
         if (input.val() == input.attr('placeholder')) {
            input.val('');
            input.removeClass('placeholder');
         }
      }).blur(function() {
         var input = $(this);
         if (input.val() == '' || input.val() == input.attr('placeholder')) {
            input.addClass('placeholder');
            input.val(input.attr('placeholder'));
         }
      }).blur().parents('form').submit(function() {
         $(this).find('[placeholder]').each(function() {
            var input = $(this);
            if (input.val() == input.attr('placeholder')) {
               input.val('');
            }
         });
      });
    };

	$('#check-password').change(function(){
		if($(this).is(':checked')){
			$('#save_pwd_popin').removeClass('hide').dialog({
				title: 'Mémoriser mon mot de passe',
				modal: true,
				draggable: false,
				resizable : false,
				height: 'auto',
				dialogClass: 'save-pwd-popin',
				buttons: [ 
				   { 
						text: __('warning_save_pwd.cancel'), 
						'class': 'btn3 button button-stroke',
						click: function() { 
							$('#check-password').prop('checked', false);
							$(this).dialog('close');
						} 
				  },
				  { 
						text: __('warning_save_pwd.confirm'), 
						'class': 'btn3 margin-right-16 button',
						click: function() { 
							$(this).dialog('close');
						} 
				   }
			   ],
			   open: function () {
				
				var block = $(this).parent('.ui-dialog');
				var title = $(this).parents(".ui-dialog:first").find(".ui-dialog-titlebar");
				var text = $(this).find('div.columns');
				var button = $(this).parents(".ui-dialog:first").find(".ui-dialog-buttonpane ");
				var overlay = $(block).siblings('.ui-widget-overlay');

				$(this).css({'padding-top':'0'});
				$(block).css({'border-radius':'15px','left':'50%','transform':'translateX(-50%) translateY(-50%)','top':'50%','width':'50%','max-width':'500px'});
				$(text).css({'padding':'0','font-size':'14px','color':'#333','margin-bottom':'20px'});
				$(title).css({'background':'#fff','border':'none','color':'#683082','text-transform':'uppercase','font-size':'20px','font-family':'Hind'}).children('button').css({'display':'none'});
				$(button).css({'display':'flex','justify-content':'center'});
				$(overlay).css({'background':'#000','opacity':'.5'});
			   }
			});
		}
	});
    
    // bg Image
    var bg = $('#bgImg');
    if (bg.length) {
        $(window).scroll(function () {
            var x = $(this).scrollTop();
            bg.css('background-position', '0% ' + parseInt(-x / 10, 10) + 'px');
        });
    }
	
	//Espace Recrutement
	$(document).on('click', '.job-header', function() {
		if (!$(this).hasClass('active')) {
			// On ferme le bloc actif quand on click sur un autre block
			$('.job-header.active').siblings('.inside-job').slideToggle(400);
			$('.job-header.active').removeClass('active');
			// On ouvre celui sur lequel on clique
			$(this).siblings('.inside-job').slideToggle(400);
			$(this).addClass('active');
		} else {
			// On ferme le bloc actif au click dessus
			$(this).removeClass('active');
			$(this).siblings('.inside-job').slideToggle(400);
		}
	});

    //Espace Presse
	$('.pressContent').each(function() {
		if ($(this).find('li').length > 4) {
			var button = '<div class="buttonContainer"><button class="button more-article" type="button">'+__('public.morearticles')+'<em class="fa fa-plus"></em></button></div>'
			var buttonPressRelease = '<div class="buttonContainer"><button class="button more-article" type="button">'+__('public.morecom')+'<em class="fa fa-plus"></em></button></div>'
			if ($(this).hasClass('pressRelease')) {
				$(this).append(buttonPressRelease);
			} else {
				$(this).append(button);
			}
			$(this).find('ul li').addClass('hide');
			$(this).find('ul li:lt(4)').removeClass('hide');
		}

		initYearSort($(this));
	});	
	
	$(document).on('change', 'input.article-year.press-releases', function() {
		changeSlides($(this), 'releases');
	});
	
	$(document).on('change', 'input.article-year.press-reviews', function() {
		changeSlides($(this), 'reviews');
	});
	
	
	$(document).on('click', '.more-article', function() {
		var listContainer = $(this).parent('.buttonContainer').prev('ul'); 
		var $select = $(this).closest('.pressContent').prev().find('.select-list');			
		$select.find('button input').val($select.find('ul li[data-value="all"]').html());

		if (listContainer.find('li:not(.hide)').length != listContainer.find('li').length) {
			listContainer.find('li.hide').removeClass('hide');
			if ($(this).parents('.pressContent').hasClass('pressRelease')) {
				$(this).html(__('public.lesscom') + '<em class="fa fa-minus"></em>');
			} else {
				$(this).html(__('public.lessarticles') + '<em class="fa fa-minus"></em>');
			}
		} else {
			if ($(this).parents('.pressContent').hasClass('pressRelease')) {
				$(this).html(__('public.morecom') + ' <em class="fa fa-plus"></em>');
			} else {
				$(this).html(__('public.morearticles') + ' <em class="fa fa-plus"></em>');
			}
			listContainer.find('li').addClass('hide');
			listContainer.find('li:lt(4)').removeClass('hide');
			var $container = $('html');
			var $scrollTo = $(this).closest('.buttonContainer').closest('.pressContent').prev('.headerPressCat');
			if ($scrollTo.length) {
				$container.animate({scrollTop: $scrollTo.offset().top},500);
			}
			
		}
	});
}); // fin de jQuery ready(function)

////////////////////////////////////////////////////////////////////////////////////////////////
//// Functions
///////////////////////////////////////////////////////////////////////////////////////////////
function initYearSort($el)
{
	var years = [];
	var $ul = $el.prev().find('.select-list ul');
	$ul.html('<li class="value" data-value="all">'+__('public.allyear')+'<li>');

	$el.find('ul li').each(function(i,e)
	{
		var year = getYearOfLi($(e));

		if(years.indexOf(year) == -1) years.push(year);
	});

	years.forEach(function(e,i)
	{
		$ul.append('<li class="value" data-value="'+e+'">'+e+'<li>');
	});
}

function getYearOfLi($el)
{
	return $el.find('.date').text().substr(6,4);
}
 
 function changeSlides($el, filter){
	var year = $el.val();

	if(year == 'all' || year == ''){
		year = '';
		
		if(filter == 'releases') {
			$('.slider.press-releases').slick('slickUnfilter');
		} 
		if(filter == 'reviews') {
			$('.slider.press-reviews').slick('slickUnfilter');
		}
	} else {
		if(filter == 'releases') {
			$('.slider.press-releases').slick('slickUnfilter');
			$('.slider.press-releases').slick('slickFilter', '.' + year);
		}
		if(filter == 'reviews') {
			$('.slider.press-reviews').slick('slickUnfilter');
			$('.slider.press-reviews').slick('slickFilter', '.' + year);
		}
	}
}